import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import './InvistaConosco.css';

const InvistaConosco = () => {
  const navigate = useNavigate();
  const [activeVideo, setActiveVideo] = useState(null);

  const processSteps = [
    {
      number: 1,
      title: 'Extração Automática de Dados',
      description: 'A MICA CAPITAL extrai automaticamente dados de precatórios de todas as fontes oficiais, criando uma base de dados estruturada.',
      video: '/Assets/Vids/extração-de-dados.mp4'
    },
    {
      number: 2,
      title: 'Previsão Precisa com RCL',
      description: 'Utilizando a receita líquida (RCL) de cada Estado, a MICA CAPITAL calcula com precisão a data prevista para o pagamento de cada precatório.',
      video: '/Assets/Vids/previsão-precisa-com-rcl.mp4'
    },
    {
      number: 3,
      title: 'Abordagem Precisa e Direcionada',
      description: 'Abordagem direcionada ao cliente com dados estruturados e previsões exatas, o sistema identifica com precisão os dados necessários para a gestão do precatório.',
      video: '/Assets/Vids/abordagem-direcionada.mp4'
    },
    {
      number: 4,
      title: 'Automatização de E-mails e Leads',
      description: 'Fluxo de comunicação inteligente e direcionamento automático da base de leads.',
      video: '/Assets/Vids/automatização-de-emails.mp4'
    },
    {
      number: 5,
      title: 'Gestão de Performance em Tempo Real',
      description: 'Monitoramento em tempo real das operações por perfil, permitindo acompanhar indicadores, status das atividades e próximos passos de forma transparente e rastreável.',
      video: '/Assets/Vids/gestão-de-performance.mp4'
    },
    {
      number: 6,
      title: 'ROI e Escalabilidade Comprovadas',
      description: 'A MICA CAPITAL é uma plataforma de tecnologia que transforma a análise e aquisição de precatórios em uma atividade altamente lucrativa, eficiente e massivamente escalável.',
      video: '/Assets/Vids/roi-e-escalabilidade.mp4'
    }
  ];

  const handleOpenVideo = (video) => {
    setActiveVideo(video);
  };

  const handleCloseVideo = () => {
    setActiveVideo(null);
  };

  const handleInvestClick = () => {
    navigate('/registro');
  };

  return (
    <div className="invista-page">
      <Header />

      <main className="main-content">
        {/* Hero Section */}
        <section className="hero-section invista-hero">
          <div className="hero-background">
            <div className="container">
              <div className="hero-content">
                <div className="hero-badge">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V7.89l7-3.11v8.2z"/>
                  </svg>
                  Investimento Seguro e Lucrativo
                </div>

                <h1 className="hero-title">
                  Invista em Precatórios com<br />
                  <span className="highlight-text">Tecnologia de IA</span>
                </h1>

                <p className="hero-subtitle">
                  A MICA CAPITAL oferece a oportunidade de investir em precatórios com segurança jurídica, previsibilidade de retorno e toda a tecnologia necessária para maximizar seus resultados.
                </p>

                <div className="hero-features">
                  <div className="feature-badge">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                    ROI Comprovado
                  </div>
                  <div className="feature-badge">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
                    </svg>
                    100% Seguro
                  </div>
                  <div className="feature-badge">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v2h12v-2l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z"/>
                    </svg>
                    Tecnologia Avançada
                  </div>
                </div>

                <button className="btn btn-primary btn-large" onClick={handleInvestClick}>
                  Quero Investir com a MICA
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Etapas do Processo Section */}
        <section className="process-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Etapas do Processo</h2>
              {/* <div className="title-divider"></div> */}
            </div>

            <div className="process-grid">
              {processSteps.map((step) => (
                <div key={step.number} className="process-card">
                  <div className="process-card-header">
                    <h3 className="process-number">{step.number}</h3>
                    <h4 className="process-title">{step.title}</h4>
                  </div>
                  <p className="process-description">{step.description}</p>
                  <button
                    className="btn-saiba-mais"
                    onClick={() => handleOpenVideo(step.video)}
                  >
                    SAIBA MAIS
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Synergy Section */}
        <section className="synergy-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title white-title">A SINERGIA PERFEITA: AUTOMAÇÃO + HUMANO</h2>
            </div>

            <div className="synergy-grid">
              <div className="synergy-column">
                <h3 className="synergy-column-title">Processos Automatizados</h3>
                <ul className="synergy-list">
                  <li>Extração de dados 24/7</li>
                  <li>Cálculos de previsão RCL</li>
                  <li>Envio de e-mails em massa</li>
                  <li>Distribuição de leads</li>
                  <li>Geração de relatórios</li>
                  <li>Validação de documentos</li>
                </ul>
              </div>

              <div className="synergy-column">
                <h3 className="synergy-column-title">Abordagem Humana</h3>
                <ul className="synergy-list">
                  <li>Relacionamento com proprietários</li>
                  <li>Negociação personalizada</li>
                  <li>Gestão de objeções</li>
                  <li>Fechamento de contratos</li>
                  <li>Decisões estratégicas</li>
                  <li>Auditoria de qualidade</li>
                </ul>
              </div>

              <div className="synergy-column">
                <h3 className="synergy-column-title">Principais Benefícios</h3>
                <ul className="synergy-list">
                  <li>Zero entrada manual de dados</li>
                  <li>Saber exatamente quando será pago</li>
                  <li>Contato certo no momento certo</li>
                  <li>Controle total da operação</li>
                  <li>Retorno de 800% no primeiro ano</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Implementation Section */}
        <section className="implementation-section">
          <div className="container">
            <div className="implementation-content">
              <h2 className="implementation-title">A MICA CAPITAL está pronta para transformar sua operação</h2>
              <p className="implementation-subtitle">Os passos para a implementação são:</p>

              <div className="implementation-steps">
                <div className="implementation-step">
                  <span className="step-number">1.</span>
                  <span className="step-text">Integração rápida com suas bases de dados</span>
                </div>
                <div className="implementation-step">
                  <span className="step-number">2.</span>
                  <span className="step-text">Treinamento completo da equipe</span>
                </div>
                <div className="implementation-step">
                  <span className="step-number">3.</span>
                  <span className="step-text">Suporte dedicado durante toda jornada</span>
                </div>
                <div className="implementation-step">
                  <span className="step-number">4.</span>
                  <span className="step-text">Resultados desde o primeiro dia</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="container">
            <div className="cta-content">
              <h2 className="cta-title">Pronto para Investir em Precatórios?</h2>
              <p className="cta-subtitle">
                Entre em contato conosco e descubra como a tecnologia MICA CAPITAL pode transformar seus investimentos.
              </p>
              <button className="btn btn-primary btn-large" onClick={handleInvestClick}>
                Começar Agora
              </button>
            </div>
          </div>
        </section>
      </main>

      {/* Video Modal */}
      {activeVideo && (
        <div className="video-modal" onClick={handleCloseVideo}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="video-modal-close" onClick={handleCloseVideo}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
              </svg>
            </button>
            <video controls autoPlay className="video-player">
              <source src={activeVideo} type="video/mp4" />
              Seu navegador não suporta a reprodução de vídeos.
            </video>
          </div>
        </div>
      )}
    </div>
  );
};

export default InvistaConosco;
